import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from 'react-router-dom';
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory from 'react-bootstrap-table2-editor';
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { tab } from '@testing-library/user-event/dist/tab';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "./table.css"
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "react-toastify/dist/ReactToastify.css";
import InvitationStatus from './InvitationStatus';
import AdminModal from './AdminModal';
import { useAdminStore, useBranchStore } from '../../stores';
import DeleteModal from './DeleteModal';

const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
//sweetalert
const MySwal = withReactContent(Swal);
const handleAdminDelete = (e, admin, branchId, removeState) => {
  e.preventDefault();
  MySwal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    showLoaderOnConfirm: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
    preConfirm: async (confirm) => {
      if (confirm) {
        try {
          const res = await fetch(`/api/super-admin/admins/${admin._id}`, {
            method: "DELETE",
            body: JSON.stringify({branch: branchId}),
            headers: {
              'Content-Type': "application/json"
            }
          });
          if (res.status !== 200) {
            const message = (await res.json()).message;
            throw Error(message);
          }
          removeState(admin._id);
          return res;
        } catch (error) {
          MySwal.showValidationMessage(
            `Request failed: ${error}`
          )
        }
      }
    },
    allowOutsideClick: () => !MySwal.isLoading()
  }).then((result) => {
    if (result.isConfirmed) {
      MySwal.fire(
        'Deleted!',
        'Your file has been deleted.',
        'success'
      )
    }
  })
}

const sortCaretEle = (order, column) => {
  const Up = () => <span style={{ content: '', borderBottom: 0, borderTop: "4px dashed" }} className='caret'></span>
  const Down = () => <span style={{ content: '', borderTop: 0, borderBottom: "4px dashed" }} className='caret'></span>
  if (!order) return (<span>&nbsp;&nbsp;<Up />&ensp;<Down /></span>);
  else if (order === 'asc') return (<span>&nbsp;&nbsp;<Down /></span>);
  else if (order === 'desc') return (<span>&nbsp;&nbsp;<Up /></span>);
  return null;
}
const headerSortingStyle = { backgroundColor: '#c8e6c9' };
const BranchAdminsTable = (props) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const deleteRef = useRef(null);
  const admins = useAdminStore(state => state.admins);
  const branch = useAdminStore(state => state.branch);
  const removeAdmin = useAdminStore(state => state.removeAdmin);
  const [openModal, setOpenModal] = useState(false);
  const [editableRow, setEditableRow] = useState(null);
  const options = {
    // pageStartIndex: 0,
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true
  };
  const columns = [
    // {
    //   dataField: 'id',
    //   text: 'SL.No',
    //   sort: true,
    //   sortCaret: sortCaretEle,
    //   headerSortingStyle: headerSortingStyle
    // },
    // {
    //   dataField: 'name',
    //   text: 'Branch',
    //   sort: true,
    //   Cell: row => (
    //     <div>
    //       <span style={{ color: "red" }} title={row.value}>{row.value}</span>
    //     </div>
    //   ),
    //   sortCaret: sortCaretEle,
    //   headerSortingStyle: headerSortingStyle,
    //   editable: (content, row, rowIndex, columnIndex) => content > 2101
    // },
    {
      dataField: 'firstName',
      text: 'H.O.D name',
      sort: true,
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle,
      editable: (content, row, rowIndex, columnIndex) => content > 2101,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return <span style={{ color: "red" }} title={content}>{row.firstName + " " + row.lastName}</span>
      }
    },
    {
      dataField: 'email',
      text: 'H.O.D email',
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle,
      editable: (content, row, rowIndex, columnIndex) => content > 2101
    },
    {
      dataField: 'years',
      text: 'Years',
      sortCaret: sortCaretEle,
      headerSortingStyle: headerSortingStyle,
      editable: (content, row, rowIndex, columnIndex) => content > 2101,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return <span style={{ color: "red" }} title={content}>{row.years.join(',')}</span>
      }
    },
    {
      dataField: 'invitation',
      text: 'Invitation',
      editable: false,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return (
          <InvitationStatus status={row.isVerified ? "accepted" : "invited"} />
        )

      }
    },
    {
      dataField: 'edit',
      text: 'Edit',
      editable: false,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return (
          <button className='btn btn-primary' onClick={(e) => { setEditableRow({...row}); setOpenModal(true); e.preventDefault(); }}>Edit</button>
        )
      }
    },
    {
      dataField: 'delete',
      text: '',
      editable: false,
      formatter: (content, row, rowIndex, formatExtraData) => {
        return (
          <button className='btn btn-danger' onClick={(e) => handleAdminDelete(e, row, branch._id, removeAdmin)}>Delete</button>
        )
      }
    },
  ];
  return (
    <>
      <AdminModal show={openModal} row={editableRow} onClose={() => setOpenModal(false)} branches={admins} />
      <DeleteModal open={openDeleteModal} ref={deleteRef} onClose={() => setOpenDeleteModal(false)} mode="branch" />
      <BootstrapTable
        keyField="id"
        data={admins}
        columns={columns}
        pagination={paginationFactory(options)}
        // cellEdit={cellEditFactory({ mode: 'click', blurToSave: true, afterSaveCell })}
        striped
        hover
        condensed
        bordered={false}
      />
    </>
  );
}
export default BranchAdminsTable;